module.exports = __webpack_public_path__ + "static/logo-60d77b4519c3cad528d51d500124aa48.svg";